<template>
  <!--  서브페이지  -->

  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">

    <a @click="btnNoticeWrite" v-if="isAdmin" class="admin writing"
              >공지사항 추가</a>

    <!-- <router-link v-if="isAdmin" class ="admin writing" to="/notice/bannerList">배너 이동</router-link> -->


    <div class="newslist">
      <table class="table_a">
              <thead>
                <tr>
                  <th>게시일</th>
                  <th>제목</th>
                  <th>첨부파일</th>
                </tr>
              </thead>
              <tbody v-for="(obj, index) in GET_LIST" :key="index">
                <tr>
                      <td>{{ obj.createdAt | date }}</td>
                      <td><a @click="btnDetail(obj)">{{ obj.title }}</a></td>
                      <td>
                          <button type="button"  v-if="obj.files != undefined" @click="btnDetail(obj)">
                            <img :src="require('./../../assets/img/sub/clip.svg')">
                          </button>
                      </td>
                </tr>
              </tbody>
        </table>
    </div>

      <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "../common/protocolManager";
export default {
  data: () => ({
    message: "NoticeList.vue",
    isAdmin: false,
  }),
  methods: {
    btnDetail(obj) {
      this.$router.push({
        path: `/notice/detail`,
        query: {
          id: obj._id,
          // 게시판 타입 = 0 : 공지사항, 1 : 소식,
          type: obj.type,
        }
      });
    },
    btnNoticeWrite() {
      this.$router.push({
        path: `/notice/NoticeWritePopup`,
        query: {
          // id: '63b381bb12e1a0174b6cce42',
          // 게시판 타입 = 0 : 공지사항, 1 : 소식,
          type: 0,
        }
      });
    },
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then(result => {
          console.log('isAdmin = true');
          this.isAdmin = true;
        })
        .catch(err => {
          console.log('isAdmin = err');
          this.isAdmin = false;
          if (localStorage.authToken) {
            localStorage.removeItem("authToken");
          }
        });
    }

  },
  computed: {
    ...mapGetters(["getNoticeList",]),
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    },
    GET_LIST() {
      console.log('length = ' + this.getNoticeList.length);

      return this.getNoticeList;
    }
  },
  destroyed() { },
  mounted() {
    this.checkAdmin();
  },
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/NoticeList.vue